import {
  Card,
  Flex,
  Grid,
  GridCell,
  InfoIconWithTooltip,
  Separator,
  SubTitle,
  Text,
} from "@shared/primitive-components"
import { rebatesStyles as styles } from "../styles"

export type SummaryChartCardProps = {
  chart: JSX.Element
  summary: JSX.Element
  isGridEqual?: boolean
  chartTitle?: string
  chartTooltip?: string
  dataTestId?: string
}

export const SummaryChartCard = ({
  chart,
  dataTestId,
  summary,
  isGridEqual,
  chartTitle,
  chartTooltip,
}: SummaryChartCardProps) => (
  <Card css={styles.safetyContainer} data-testid={dataTestId}>
    <Grid css={styles.safetyWrap}>
      <GridCell tablet={isGridEqual ? 8 : 6} desktop={isGridEqual ? 6 : 4} css={styles.safetyItemLeft}>
        {summary}
      </GridCell>
      <GridCell tablet={isGridEqual ? 8 : 10} desktop={isGridEqual ? 6 : 8} align="bottom" css={styles.safetyItemRight}>
        {chartTitle && (
          <>
            <Flex alignItems="center">
              <SubTitle>{chartTitle}</SubTitle>
              {chartTooltip && (
                <InfoIconWithTooltip content={<Text css={styles.tooltipContent}>{chartTooltip}</Text>} />
              )}
            </Flex>
            <Separator size="block" color="yellow" css={styles.separator(2)} />
          </>
        )}
        {chart}
      </GridCell>
    </Grid>
  </Card>
)

SummaryChartCard.defaultProps = {
  isGridEqual: true,
  chartTitle: undefined,
  chartTooltip: undefined,
  dataTestId: undefined,
}
